import React, { useState } from 'react'
import SupplyOrderItem from './SupplyOrderItem'
import SupplyOrderItemsTable from './SupplyOrderItemsTable'
import SupplyOrderItemsActions from './actions/SupplyOrderItemsActions'

const SupplyOrderItems = ({ supplyOrderId }) => {

	const [checked, setChecked] = useState({})

	// console.log('checked', checked)

  return (
    <div>
        <h4>Позиції заявки</h4>

		<SupplyOrderItemsActions 
			supplyOrderId={supplyOrderId}
			// supplyOrderItems={supplyOrderItems}
			checked={checked}
      setChecked={setChecked}
		/>

        <SupplyOrderItemsTable 
            // supplyOrderItems={supplyOrderItems}
			checked={checked}
			setChecked={setChecked}
        />
    </div>
  )
}

export default SupplyOrderItems